/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OverwatchMapListTaxonomiesQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
}>

export type OverwatchMapListTaxonomiesQuery = {
  __typename?: 'Query'
  taxonomies: Array<string>
}

export type OverwatchMapOddElementsQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
  taxonomies?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
  oddElementTypes?: Types.InputMaybe<
    Array<Types.OddElementType> | Types.OddElementType
  >
}>

export type OverwatchMapOddElementsQuery = {
  __typename?: 'Query'
  oddElements: Array<{
    __typename?: 'ODDElement'
    taxonomy: string
    elementType: Types.OddElementType
    location: {
      __typename?: 'Geolocation'
      latitude: number
      longitude: number
    } | null
  }>
}

export type OverwatchMapOddElementsByAttributesQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
  targetOddElementType: Types.OddElementType
  includeOddElementTypes?: Types.InputMaybe<
    Array<Types.OddElementType> | Types.OddElementType
  >
  excludeOddElementTypes?: Types.InputMaybe<
    Array<Types.OddElementType> | Types.OddElementType
  >
}>

export type OverwatchMapOddElementsByAttributesQuery = {
  __typename?: 'Query'
  oddElementsByAttributes: {
    __typename?: 'PaginatedODDElements'
    elements: Array<{
      __typename?: 'ODDElement'
      taxonomy: string
      elementType: Types.OddElementType
      location: {
        __typename?: 'Geolocation'
        latitude: number
        longitude: number
      } | null
    }>
  }
}

export const OverwatchMapListTaxonomiesDocument = gql`
    query OverwatchMapListTaxonomies($metroId: Int!) {
  taxonomies(metroId: $metroId)
}
    `

/**
 * __useOverwatchMapListTaxonomiesQuery__
 *
 * To run a query within a React component, call `useOverwatchMapListTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapListTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapListTaxonomiesQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *   },
 * });
 */
export function useOverwatchMapListTaxonomiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  > &
    (
      | { variables: OverwatchMapListTaxonomiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  >(OverwatchMapListTaxonomiesDocument, options)
}
export function useOverwatchMapListTaxonomiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  >(OverwatchMapListTaxonomiesDocument, options)
}
// @ts-ignore
export function useOverwatchMapListTaxonomiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapListTaxonomiesQuery,
  OverwatchMapListTaxonomiesQueryVariables
>
export function useOverwatchMapListTaxonomiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapListTaxonomiesQuery,
        OverwatchMapListTaxonomiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapListTaxonomiesQuery | undefined,
  OverwatchMapListTaxonomiesQueryVariables
>
export function useOverwatchMapListTaxonomiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapListTaxonomiesQuery,
        OverwatchMapListTaxonomiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapListTaxonomiesQuery,
    OverwatchMapListTaxonomiesQueryVariables
  >(OverwatchMapListTaxonomiesDocument, options)
}
export type OverwatchMapListTaxonomiesQueryHookResult = ReturnType<
  typeof useOverwatchMapListTaxonomiesQuery
>
export type OverwatchMapListTaxonomiesLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapListTaxonomiesLazyQuery
>
export type OverwatchMapListTaxonomiesSuspenseQueryHookResult = ReturnType<
  typeof useOverwatchMapListTaxonomiesSuspenseQuery
>
export type OverwatchMapListTaxonomiesQueryResult = Apollo.QueryResult<
  OverwatchMapListTaxonomiesQuery,
  OverwatchMapListTaxonomiesQueryVariables
>
export const OverwatchMapOddElementsDocument = gql`
    query OverwatchMapOddElements($metroId: Int!, $taxonomies: [String!], $oddElementTypes: [ODDElementType!]) {
  oddElements(
    metroId: $metroId
    taxonomies: $taxonomies
    oddElementTypes: $oddElementTypes
  ) {
    taxonomy
    elementType
    location {
      latitude
      longitude
    }
  }
}
    `

/**
 * __useOverwatchMapOddElementsQuery__
 *
 * To run a query within a React component, call `useOverwatchMapOddElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapOddElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapOddElementsQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *      taxonomies: // value for 'taxonomies'
 *      oddElementTypes: // value for 'oddElementTypes'
 *   },
 * });
 */
export function useOverwatchMapOddElementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  > &
    (
      | { variables: OverwatchMapOddElementsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  >(OverwatchMapOddElementsDocument, options)
}
export function useOverwatchMapOddElementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  >(OverwatchMapOddElementsDocument, options)
}
// @ts-ignore
export function useOverwatchMapOddElementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOddElementsQuery,
  OverwatchMapOddElementsQueryVariables
>
export function useOverwatchMapOddElementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOddElementsQuery,
        OverwatchMapOddElementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOddElementsQuery | undefined,
  OverwatchMapOddElementsQueryVariables
>
export function useOverwatchMapOddElementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOddElementsQuery,
        OverwatchMapOddElementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapOddElementsQuery,
    OverwatchMapOddElementsQueryVariables
  >(OverwatchMapOddElementsDocument, options)
}
export type OverwatchMapOddElementsQueryHookResult = ReturnType<
  typeof useOverwatchMapOddElementsQuery
>
export type OverwatchMapOddElementsLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapOddElementsLazyQuery
>
export type OverwatchMapOddElementsSuspenseQueryHookResult = ReturnType<
  typeof useOverwatchMapOddElementsSuspenseQuery
>
export type OverwatchMapOddElementsQueryResult = Apollo.QueryResult<
  OverwatchMapOddElementsQuery,
  OverwatchMapOddElementsQueryVariables
>
export const OverwatchMapOddElementsByAttributesDocument = gql`
    query OverwatchMapOddElementsByAttributes($metroId: Int!, $targetOddElementType: ODDElementType!, $includeOddElementTypes: [ODDElementType!], $excludeOddElementTypes: [ODDElementType!]) {
  oddElementsByAttributes(
    metroId: $metroId
    targetOddElementType: $targetOddElementType
    includeOddElementTypes: $includeOddElementTypes
    excludeOddElementTypes: $excludeOddElementTypes
  ) {
    elements {
      taxonomy
      elementType
      location {
        latitude
        longitude
      }
    }
  }
}
    `

/**
 * __useOverwatchMapOddElementsByAttributesQuery__
 *
 * To run a query within a React component, call `useOverwatchMapOddElementsByAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapOddElementsByAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapOddElementsByAttributesQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *      targetOddElementType: // value for 'targetOddElementType'
 *      includeOddElementTypes: // value for 'includeOddElementTypes'
 *      excludeOddElementTypes: // value for 'excludeOddElementTypes'
 *   },
 * });
 */
export function useOverwatchMapOddElementsByAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  > &
    (
      | {
          variables: OverwatchMapOddElementsByAttributesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  >(OverwatchMapOddElementsByAttributesDocument, options)
}
export function useOverwatchMapOddElementsByAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  >(OverwatchMapOddElementsByAttributesDocument, options)
}
// @ts-ignore
export function useOverwatchMapOddElementsByAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOddElementsByAttributesQuery,
  OverwatchMapOddElementsByAttributesQueryVariables
>
export function useOverwatchMapOddElementsByAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOddElementsByAttributesQuery,
        OverwatchMapOddElementsByAttributesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapOddElementsByAttributesQuery | undefined,
  OverwatchMapOddElementsByAttributesQueryVariables
>
export function useOverwatchMapOddElementsByAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapOddElementsByAttributesQuery,
        OverwatchMapOddElementsByAttributesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapOddElementsByAttributesQuery,
    OverwatchMapOddElementsByAttributesQueryVariables
  >(OverwatchMapOddElementsByAttributesDocument, options)
}
export type OverwatchMapOddElementsByAttributesQueryHookResult = ReturnType<
  typeof useOverwatchMapOddElementsByAttributesQuery
>
export type OverwatchMapOddElementsByAttributesLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapOddElementsByAttributesLazyQuery
>
export type OverwatchMapOddElementsByAttributesSuspenseQueryHookResult =
  ReturnType<typeof useOverwatchMapOddElementsByAttributesSuspenseQuery>
export type OverwatchMapOddElementsByAttributesQueryResult = Apollo.QueryResult<
  OverwatchMapOddElementsByAttributesQuery,
  OverwatchMapOddElementsByAttributesQueryVariables
>
